import ListContentMdl from '../uc/listContent/ListContentMdl';

const ContentReducer = {
    listContentMdl: ListContentMdl,
};

export default ContentReducer;
